export const LoanChangesHistoryEntityType = {
  LOAN: 'Loan',
  LOAN_ADJUSTMENT: 'LoanAdjustment',
  LOAN_CUSTOM_ADJUSTMENT: 'LoanCustomAdjustment',
  LOAN_LOCK_EXTENSION: 'LoanLockExtension',
  LOAN_FEE: 'LoanFee',
  CLOSING_COMPANY: 'ClosingCompany',
  APPLICATION_IMPOUND: 'ApplicationImpound',
  APPLICATION_SELLER_ADJUSTMENT: 'ApplicationSellerAdjustment',
  LOAN_FEE_HISTORY: 'LoanFeeHistory',
  LOAN_CIC_FEE_REASON: 'LoanCicFeeReason',
  APPLICATION: 'Application',
  BORROWER: 'ApplicationBorrower',
  NON_BORROWER_ENTITY: 'ApplicationNonBorrowerEntity',
  RESIDENCE: 'ApplicationResidence',
  ADDRESS: 'ApplicationAddress',
  PROPERTY: 'ApplicationProperty',
  PROPERTY_TRUSTEE: 'PropertyTrustee',
  BORROWER_PROPERTY: 'ApplicationBorrowerProperty',
  TITLE_HOLDER: 'ApplicationTitleHolder',
  TRUST: 'ApplicationTrust',
  INCOME: 'ApplicationIncome',
  ASSET: 'ApplicationAsset',
  BORROWER_ASSET: 'ApplicationBorrowerAsset',
  LIABILITY: 'ApplicationLiability',
  BORROWER_LIABILITY: 'ApplicationBorrowerLiability',
  LOAN_FUNDING: 'LoanFunding',
  LOAN_CLOSING_INVESTOR: 'LoanClosingInvestor',
  APPLICATION_ADDITIONAL_MORTGAGE: 'ApplicationAdditionalMortgage',
  APPLICATION_PROGRAM_IDENTIFIER: 'ApplicationProgramIdentifier',
  DOCUMENT_EXPIRATION_DATE: 'DocumentExpirationDate',
  CUSTOM_FIELD: 'CustomField',
  LOAN_APPRAISAL_SURCHARGE: 'LoanAppraisalSurcharge',
  LOAN_APPRAISAL_ORDER_CONTACT: 'LoanAppraisalOrderContact',
  EXISTING_PROPERTY_EXPENSES: 'ExistingPropertyExpenses',
};

export const LoanChangesHistoryFieldType = {
  ID: 'Guid',
  DATE_TIME: 'DateTime',
  SELECT: 'select',
};

export const AllowedIdsByEntityTypeInLoanChangesHistory = {
  [LoanChangesHistoryEntityType.LOAN]: [
    'loanOfficerId',
    'programId',
    'rateSheetId',
    'vestingTypeId',
  ],
  [LoanChangesHistoryEntityType.APPLICATION]: ['leadSourceId'],
  [LoanChangesHistoryEntityType.PROPERTY]: ['firstMortgageId', 'secondMortgageId'],
  [LoanChangesHistoryEntityType.BORROWER_PROPERTY]: ['borrowerId'],
  [LoanChangesHistoryEntityType.BORROWER_ASSET]: ['borrowerId'],
  [LoanChangesHistoryEntityType.BORROWER_LIABILITY]: ['borrowerId'],
  [LoanChangesHistoryEntityType.LOAN_ADJUSTMENT]: ['criteriaId'],
  [LoanChangesHistoryEntityType.LOAN_FEE]: ['feeTypeId'],
  [LoanChangesHistoryEntityType.APPLICATION_IMPOUND]: ['impoundTypeId'],
  [LoanChangesHistoryEntityType.APPLICATION_SELLER_ADJUSTMENT]: ['sellerAdjustmentTypeId'],
  [LoanChangesHistoryEntityType.LOAN_CIC_FEE_REASON]: ['cicFeeReasonId'],
  [LoanChangesHistoryEntityType.CLOSING_COMPANY]: ['attendantCompanyId'],
  [LoanChangesHistoryEntityType.LOAN_FUNDING]: ['warehouseBankId'],
  [LoanChangesHistoryEntityType.LOAN_CLOSING_INVESTOR]: ['investorId'],
  [LoanChangesHistoryEntityType.APPLICATION_PROGRAM_IDENTIFIER]: ['programIdentifierId'],
};

export const LoanProgramChangeOwner = {
  PROGRAM: 'LoanProgram',
  ARM_TERMS: 'LoanProgram.ArmTerms',
  INDEX: 'LoanProgram.Index',
  PREPAYMENT_PENALTY: 'LoanProgram.PrepaymentPenalty',
  INITIAL_DRAW_PERIOD: 'LoanProgram.InitialDrawPeriod',
  REPAYMENT_PERIOD: 'LoanProgram.RepaymentPeriod',
  LOAN_CHARACTERISTICS: 'LoanProgram.LoanCharacteristics',
  ASSUMABLE_DETAILS_GROUP: 'LoanProgram.AssumableDetailsGroup',
};

export const LoanProfitAndLossChangeOwner = {
  PROFIT_AND_LOSS: 'ProfitAndLoss',
};
